// src/components/ProductCardSkeleton.js
import React from 'react';
import './ProductCardSkeleton.css';

/**
 * Enhanced ProductCardSkeleton component that shows a realistic loading placeholder
 * with animated shimmer effects for better perceived performance.
 * 
 * @returns {JSX.Element} A skeleton UI for product cards during loading
 */
const ProductCardSkeleton = () => {
  return (
    <div className="product-card-skeleton">
      {/* Country flag placeholder */}
      <div className="country-flag-skeleton skeleton"></div>
      
      {/* Image placeholder with shimmer effect */}
      <div className="product-image-skeleton skeleton"></div>
      
      <div className="product-info-skeleton">
        {/* Product title placeholders with staggered animations */}
        <div className="product-title-skeleton skeleton"></div>
        <div className="product-title-skeleton-2 skeleton"></div>
        
        {/* Price placeholder */}
        <div className="product-price-skeleton skeleton"></div>
        
        {/* Button placeholder */}
        <div className="product-button-skeleton skeleton"></div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;